// extracted by mini-css-extract-plugin
module.exports = {"component":"SelectPackage_component__OYED_","content":"SelectPackage_content__1U6YE","title":"SelectPackage_title__3pyRi","subtitle":"SelectPackage_subtitle___qJcS"};